import React, { useState } from "react";
import styled from "styled-components";

export default function UserSelectOptionView(props) {
  const { selectOptions } = props;

  const [clickedEvent, setClickedEvent] = useState(-1);

  return (
    <TopLevelWrapper>
      {
        selectOptions.map((selectOption, selectOptionIndex) => (
          <ColumnBox 
            key={'SelectOption-' + selectOptionIndex} 
            isClicked={selectOption.id === clickedEvent}
            onClick={() => setClickedEvent(selectOption.id)}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={18} color={selectOption.id === clickedEvent ? `#FFFFFF` : `#333333`} cursor='pointer'>{selectOption.name}</Text>
          </ColumnBox>
        ))
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  flex-wrap: wrap;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: calc(48.55% - 2px);
  height: 53px;

  border-radius: 8px;
  border: ${props => props.isClicked ? `1px solid #6DD49E` : `1px solid #EDEDED`};
  background-color: ${props => props.isClicked ? `#6DD49E` : `#F9F9F9`};

  :hover {
    cursor: pointer;
  }
    
  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;